import { message } from 'antd';
import { get, post } from '../../utils/http';
// import { IModuleCtx } from 'models';

export const getProjectList = async (params: any) => {
  const res = await get('api/corpus/getProjectList', params);
  // actionCtx.setState({
  //   ...moduleState,
  //   projectInfo: {
  //     ...res,
  //   },
  // });

  return res;
};

export const getProjectDetail = async (params: any) => {
  const res = await get('api/corpus/getProjectDetail', params);

  return res;
};

export const modifyProjectInfo = async (params: any) => {
  try {
    const res = await post('api/corpus/modifyProjectInfo', params);
    return res;
  } catch (error) {
    message.error(error.message);
    return false;
  }
};

export const modifyTaskInfo = async (params: any) => {
  try {
    const res = await post('api/corpus/modifyTaskInfo', params);
    return res;
  } catch (error) {
    message.error(error.message);
    return false;
  }
};

export const modifyTaskList = async (params: any) => {
  try {
    const res = await post('api/corpus/modifyTaskList', params);
    return res;
  } catch (error) {
    message.error(error.message);
    return false;
  }
};

export const deleteTaskInfo = async (params: any) => {
  try {
    const res = await post('api/corpus/deleteTaskInfo', params);
    return res;
  } catch (error) {
    message.error(error.message);
    return false;
  }
};
export const getTaskList = async (params: any) => {
  const res = await get('api/corpus/getTaskList', params);
  return res;
};
export const getTaskDetail = async (params: any) => {
  const res = await get('api/corpus/getTaskDetail', params);
  return res;
};
export const getMarkUsers = async (params: any) => {
  const res = await get('api/corpus/getMarkUsers', params);
  return res;
};

export const getUserList = async (params: any) => {
  const res = await get('api/corpus/getUserList', params);
  return res;
};

export const getDefaultUserList = async (params: any) => {
  const res = await get('api/corpus/getDefaultUserList', params);
  return res;
};

export const getThemeList = async (params: any, moduleState: any, actionCtx: any) => {
  const res = await get('api/corpus/getThemeList', params);
  actionCtx.setState({ ...moduleState, themeList: res || [] });
  return res;
};
export const getBotTypeList = async (params: any, moduleState: any, actionCtx: any) => {
  const res = await get('api/corpus/getBotTypeList', params);
  actionCtx.setState({ ...moduleState, botTypeList: res || [] });
  return res;
};
export const getRejectReasonList = async (params: any, moduleState: any, actionCtx: any) => {
  const res = await get('api/corpus/getRejectReasonList', params);
  actionCtx.setState({ ...moduleState, reasonList: res || [] });
  return res;
};
export const getSessionList = async (params: any) => {
  const res = await get('api/corpus/getSessionList', params);
  return res;
};
export const addSession = async (params: any) => {
  try {
    const res = await post('api/corpus/addSession', params);
    return res;
  } catch (error) {
    message.error(error.message);
    return false;
  }
};
export const addQaList = async (params: any) => {
  try {
    const res = await post('api/corpus/addQaList', params);
    return res;
  } catch (error) {
    message.error(error.message);
    return false;
  }
};
export const getBotList = async (params: any, moduleState: any, actionCtx: any) => {
  const res = await get('api/corpus/getBotList', params);
  actionCtx.setState({ ...moduleState, botList: res?.botList || [] });
  return res;
};
export const updateBot = async (params: any) => {
  try {
    const res = await post('api/corpus/updateBot', params);
    return res;
  } catch (error) {
    message.error(error.message);
    return false;
  }
};

export const addBot = async (params: any) => {
  try {
    const res = await post('api/corpus/addBot', params);
    return res;
  } catch (error) {
    message.error(error.message);
    return false;
  }
};
export const addBotLists = async (params: any) => {
  try {
    const res = await post('api/corpus/addBotLists', params);
    return res;
  } catch (error) {
    message.error(error.message);
    return false;
  }
};

export const updateTaskBotInfo = async (params: any) => {
  try {
    const res = await post('api/corpus/updateTaskBotInfo', params);
    return res;
  } catch (error) {
    message.error(error.message);
    return false;
  }
};
